<template>
  <div
    v-if="UIConfig"
    id="header"
    class="header"
  >
    <shared-head-view
      v-if="UIConfig.head"
      ref="headView"
      :config="UIConfig.head"
      :button-colors="buttonColors"
    />

    <shared-toolbar-view
      v-if="UIConfig.toolbar"
      :config="UIConfig.toolbar"
      :button-colors="buttonColors"
      @changeZoom="onChangeZoom"
    />
  </div>
</template>

<script>
import globalStore from '$$globalStore';
import constants from '$$helpers/constants';
import SharedHeadView from './SharedHeadView.vue';
import SharedToolbarView from './SharedToolbarView.vue';

export default {
  name: 'SharedHeader',
  components: {
    SharedHeadView,
    SharedToolbarView,
  },
  props: {
    ganttInstance: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      buttonColors: {
        color: '#333333',
        labelColor: '#191919',
        activeColor: '#11519A',
        hoverBg: '#F2F2F2',
        activeBg: '#D0E0F2',
        activeHoverBg: '#A1C1E6',
      },
    };
  },
  computed: {
    UIConfig() {
      const UIConfig = globalStore.getters['headerView/UIConfig'];

      return UIConfig;
    },
  },
  methods: {
    onChangeZoom(value) {
      this.ganttInstance.callEvent('export:onZoomChange', [constants.ZOOM.zoomValueToMode[value]]);
    },
  },
};
</script>
